/* eslint-disable vue/require-v-for-key */
<template>
    <div class="steamerTicket">
        <div class="steamerTicket-back" :style="{backgroundImage:'url('+bkimg+')'}"></div>
        <div class="steamerTicket-content">
            <div class="steamerTicket-content-left">
                <div class="share"  @click='showShare'>
                    <img src="../assets/share3.png" alt="">
                </div>
                <Share  v-show='shareshow'></Share>
                <div class="content-left-tabtitle" style="font-weight:bold;margin:38px 0 28px 0;font-size:24px;">{{baseContent.title}}</div>
                <div class="routeDetail-left-tabtitle" style="color:#6a7176;margin:28px 0;font-size:14px;">
                    <img style="width:16px;height:15px;margin-right:10px;" src="../assets/router-detail-icon1.png" alt="">
                    <span>出发时间:{{baseContent.travelBeginTime}}  </span>
                    <img style="width:16px;height:16px;margin-right:10px;margin-left:10px;" src="../assets/router-detail-icon2.png" alt="">
                    <span style="margin-right:15px;">行程时间:{{baseContent.travelPeriod}}</span>
                    <img style="width:19px;height:19px;margin-right:10px;" src="../assets/router-detail-icon3.png" alt="">
                    <span style="margin-right:15px;">目的地:{{menusid[baseContent.destId]}}</span>
                </div>
                <div class="content-left-tab">
                    <div :class='["content-left-tab-item",item.active?"contentactive":""]' v-for="(item,index) in tabs" :key="index" @click='itemchange(index)'>{{item.name}}</div>
                </div>
                <div class="content-left-contents l0">
                    <div class="content-left-content" :class="'l'+index" v-for="(a,index) in A" :key='index'>
                        <div class="content-left-content-title-box"><img class="content-left-content-title" src="../assets/title-back.png" alt=""><span class="content-left-content-title2">{{a.contentDetail.title}}</span></div>
                        <div class="content-left-content-introduce" v-if="a.contentDetail.detailType===0">
                            <div v-html="(a.contentDetailDetails)[0].detail"></div>
                        </div>
                        <div class="content-left-content-table"     v-if="a.contentDetail.detailType===1">
                            <div v-for="(b,index) in a.contentDetailDetails" :key="index">
                                <div>
                                    <!-- <div class="content-left-content-table-title">{{b.title}}</div> -->
                                    <div v-html="b.detail"></div>
                                </div>
                            </div>

                        </div>
                        <div class="content-left-content-last"      v-if="a.contentDetail.detailType===2">
                            <div class="routerDetail-question-box" v-for="(b,index) in a.contentDetailDetails" :key="index">
                                <div class="routerDetail-question">
                                    <div class="routerDetail-question-one">问</div>
                                    <div class="routerDetail-question-two">{{b.title}}</div>
                                    <div class="routerDetail-question-three">{{b.addTime}}</div>
                                </div>
                                <div class="routerDetail-question-answerBox">
                                    <div class="routerDetail-question-answer" v-for="(c,index) in (b.detail.split(','))" :key="index">
                                        <div class="routerDetail-question-answer-one">答</div>
                                        <div class="routerDetail-question-answer-two">
                                            <div>{{c}}</div>
                                        </div>
                                    </div>
                                    <!-- <div class="routerDetail-question-answer-keep">继续查看2条回答∨</div> -->
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="steamerTicket-content-right">
                <div class="routeDetail-btns">
                    <div class="routeDetail-btn btn1" @click='expect'><img src="../assets/routeDetail-btn1.png" alt="" style="margin-right:5px;"><span>预订行程</span></div>
                    <div class="routeDetail-btn btn2"  @click='quest'><img src="../assets/routeDetail-btn2.png" alt="" style="margin-right:5px;"><span>立即咨询</span></div>
                    <div class="routeDetail-btn btn3" @click='book'><img src="../assets/routeDetail-btn3.png" alt="" style="margin-right:5px;"><span>我要订制</span></div>
                </div>
                <!-- <div class="steamerTicket-content-right-route">
                    <div class="content-right-route-title">相关路线</div>

                    <Lists2 :sidelists="sidelists2"></Lists2>

                </div> -->
                <div class="steamerTicket-content-right-route">
                    <div class="content-right-route-title">往期回顾</div>
                    <Lists2 :sidelists="sidelists"></Lists2>
                </div>
            </div>
        </div>
        <div class="steamerTicket-like">
            <div class="steamerTicket-like-title">
                <div class="steamerTicket-like-title-left" style="font-size:24px;font-weight:bold;7f8286">猜你喜欢</div>
                <div class="steamerTicket-like-title-right" style="" @click="change">换一批 <span class="imgg"></span></div>
            </div>
            <div class="content-left-content-list">
                <Lists :lists="hotlists"></Lists>
            </div>
        </div>
        <Book v-show='bookshow'></Book>
        <Expect v-show='expectshow'></Expect>
    </div>
</template>

<script>
import bkimg from '@/assets/routeDetail-back.png'
import Lists2 from '@/components/ListsContent2.vue'
import Lists from '@/components/ListsContent.vue'
import Book from '@/components/book/book.vue'
import Share from '@/components/share/share.vue'
import Expect from '@/components/warning/expect.vue'
import {getRouteDetail, getDestination, reviewdetail, recommendedRoutes} from '@/api/router.js'
import {querycontent} from '@/api/content.js'
import {sliceDate} from '@/utils/index.js'

export default {
  data () {
    return {
      id: '',
      destName: '',
      destId: '',
      A: [],
      baseContent: {},
      detailsArr: [],
      bigArr: [],
      activeName: 'second',
      tabs: [
        // {'name': '行程亮点', 'index': '0', active: true}, {'name': '每日行程', 'index': '1', active: false}, {'name': '费用明细', 'index': '2', active: false}, {'name': '预定须知', 'index': '3', active: false}, {'name': '常见问题解答', 'index': '4', active: false}
      ],
      tableHeader: [{'name': '三人套房', 'index': 0}, {'name': '三人套房', 'index': 0}, {'name': '三人套房', 'index': 1}, {'name': '主甲板套房', 'index': 2}, {'name': '经典套房', 'index': 3}, {'name': '高级套房', 'index': 4}, {'name': '豪华套房', 'index': 5}, {'name': '奢华套房', 'index': 6}],
      lists: [
        // {
        //   classes: '[极地探险-北极路线]',
        //   name: '南极长城马拉松',
        //   address: '北京/重庆集合',
        //   time: '2019-01-01至2019-01-13',
        //   tag: ['特别刺激', '完美体验'],
        //   imgPath: require('../assets/img/hot-router-img.png'),
        //   userTag: ['企鹅/海豹', '网红拍摄地点', '家庭亲子游'],
        //   active: true
        // },
        // {
        //   classes: '[极地探险-北极路线]',
        //   name: '南极长城马拉松',
        //   address: '北京/重庆集合',
        //   time: '2019-01-01至2019-01-13',
        //   tag: ['特别刺激', '完美体验'],
        //   userTag: ['企鹅/海豹', '网红拍摄地点', '家庭亲子游'],
        //   imgPath: require('../assets/img/hot-router-img.png'),
        //   active: false
        // },
        // {
        //   classes: '[极地探险-北极路线]',
        //   name: '南极长城马拉松',
        //   address: '北京/重庆集合',
        //   time: '2019-01-01至2019-01-13',
        //   tag: ['特别刺激', '完美体验'],
        //   userTag: ['企鹅/海豹', '网红拍摄地点', '家庭亲子游'],
        //   imgPath: require('../assets/img/hot-router-img.png'),
        //   active: false
        // }
      ],
      sidelists: [
        // {
        //   name: '北极路线1',
        //   introduce: '北极路线北极路线北极路线',
        //   money: 12345,
        //   num: 197,
        //   imgPath: require('../assets/steamerTicket-route.png'),
        //   active: true
        // },
        // {
        //   name: '北极路线2',
        //   introduce: '北极路线北极路线北极路线',
        //   money: 12345,
        //   num: 197,
        //   imgPath: require('../assets/steamerTicket-route.png'),
        //   active: false
        // }
      ],
      sidelists2: [],
      bookshow: false,
      expectshow: false,
      shareshow: false,
      hotquery: {
        page: 1,
        limit: 3,
        ishot: true
      },
      hotlists: [],
      hottotal: '',
      bkimg: bkimg,
      menusid: {}
    }
  },
  components: {
    Lists,
    Lists2,
    Book,
    Expect,
    Share
  },
  created () {
    if (this.$route.query.img) {
      this.bkimg = this.$route.query.img
    }
    this.id = this.$route.query.id
    this.getDestination()
    this.getRouteDetail(this.id)
    this.reviewdetail(this.id)
    this.recommendedRoutes()
    this.gethotlist()
  },
  methods: {
    getRouteDetail (id) {
      getRouteDetail({id: id}).then(res => {
        console.log(res)
        this.baseContent = res.data.data.content
        this.destId = res.data.data.content.destId
        this.A = res.data.data.contentDetails
        this.bkimg = res.data.data.content.thumbnail
        let c = res.data.data.contentDetails
        let temArr = []
        for (var i = 0; i < c.length; i++) {
          let temObj = {}
          temObj.name = c[i].contentDetail.title
          temObj.index = i
          temObj.active = false
          temArr.push(temObj)
        }
        temArr[0].active = true
        this.tabs = temArr
        this.getDestination()
      })
    },
    getDestination () {
      getDestination({page: 1, limit: 1000}).then(res => {
        let items = res.data.data.items
        let _this = this
        items.forEach(element => {
          _this.menusid[element.id] = element.dname
        })
      })
    },
    reviewdetail (id) {
      reviewdetail({id: id}).then(res => {
        console.log(res)
        let temArr = res.data.data.items.slice(0, 5)
        this.sidelists = temArr
      })
    },
    gethotlist () {
      querycontent(this.hotquery).then(res => {
        let items = res.data.data.items
        for (let i = 0; i < items.length; i++) {
          items[i].time = `${sliceDate(items[i].travelBeginTime)}至${sliceDate(items[i].travelEndTime)}`
        //   items[i].classes = this.themes[items[i].themeId]
        }
        this.hotlists = items
        this.hottotal = res.data.data.total
      })
    },
    change () {
      if (this.hottotal <= this.hotquery.page * 3) {
        this.hotquery.page = 1
      } else {
        this.hotquery.page += 1
      }
      this.gethotlist()
    },
    recommendedRoutes () {
      recommendedRoutes({isHot: true}).then(res => {
        console.log(res)
        let temArr = res.data.data.items.slice(0, 5)
        this.sidelists2 = temArr
      })
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    // 跳到我要订制页面
    book () {
      this.$router.push('/recommendedRoute')
    },
    // 弹出立即咨询
    quest () {
      this.bookshow = true
    },
    showShare () {
      this.shareshow = !this.shareshow
    },
    expect () {
      this.expectshow = true
      setTimeout(() => { this.expectshow = false }, 1000)
    },
    // 关闭立即咨询
    cancel () {
      this.bookshow = false
    },
    // 切换导航栏
    itemchange (index) {
      this.tabfalse()
      this.tabs[index].active = true
      var el = document.getElementsByClassName(`l${index}`)[0]
      if (this.showIndex === index) {
        this.showIndex = null
      } else {
        this.showIndex = index
      }
      this.$nextTick(function () {
        window.scrollTo({'behavior': 'smooth', 'top': el.offsetTop})
      })
    },
    // 导航栏active false
    tabfalse () {
      for (let i = 0; i < this.tabs.length; i++) {
        this.tabs[i].active = false
      }
    }
  }
}
</script>

<style scoped>
.steamerTicket{
    width:100%;
    height:100%;
    background:#eee;
    position: relative;
    padding-bottom:40px;
}
.steamerTicket-back{
    width:100%;
    height:670px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
}
.steamerTicket-content{
    width:1280px;
    margin:0 auto;
    background:#fff;
    /* transform:translateY(-196px); */
    margin-top:-196px;
    padding:0px 24px;
    box-sizing: border-box;
    display:flex;
}
.steamerTicket-content-left{
    flex:1;
    padding-right:24px;
    box-sizing:border-box;
    position: relative;
}
.content-left-top{
    height:58px;
    line-height:58px;
    border-bottom:1px solid #eee;
}
.share{
    width:40px;
    height:27px;
    line-height:27px;
    background:rgba(255,153,0,1);
    border-radius:13px 0px 0px 13px;
    position: absolute;
    right:0;
    top:40px;
    text-align: center;
    cursor:pointer;
}
.share img{
    width:15px;
    height:15px;
    margin-top: 5px;
    margin-left: 3px;
}
.content-left-tab{
    background: #eee;
    display: flex;
    height:44px;
    line-height:44px;
    font-size:14px;
    position: relative;
    margin-bottom:30px;
}
.content-left-tab-item{
   flex:0 0 100px;
   text-align: center;
   /* border-bottom:2px solid #0080cc; */
}
.content-left-tab-item:hover{
   border-bottom:3px solid #0080cc;
   background:#edf3f7;
   cursor:pointer;
}
.contentactive{
    border-bottom:3px solid #0080cc;
   background:#edf3f7;
   color:#0080cc;
}
.content-left-tab-btn{
    height:50px;
    line-height:50px;
    padding:0 24px;
    font-size:16px;
    background: #ff6600;
    color:#fff;
    position: absolute;
    right:0;
    bottom:0;
}
.content-left-contents{
    width:895px;
}
.content-left-content{
    margin-bottom:28px;
}
.content-left-content-title-box{
    position: relative;
}
.content-left-content-title{
    width:136px;
    height:42px;
    margin-bottom:20px;
}
.content-left-content-title2{
    position: absolute;
    top:10px;
    left:13px;
    color:#fff;
    font-size: 16px;
}
.content-left-content-more{
    color:#c0c6c9;
    font-size:14px;
    position: absolute;
    right:0;
    top: -30px;
}
.content-left-content-list{
    display:flex;
    justify-content: space-between;
    position: relative;
}
.content-item{
    flex:0 0 32%;
    /* height:100px; */
    /* margin-right:10px; */
    /* margin-bottom:10px; */
    border:1px solid #eee;
    position: relative;
}
.content-item-img{
    width:100%;
    height:196px;
}
.content-item-word{
    width:100%;
    box-sizing: border-box;
    padding:10px;
}
.content-item-tag{
    display:flex;
    flex-wrap:wrap;
    box-sizing: border-box;
    padding:10px;
    padding-top:0px;
}
.content-item-tag-item{
    padding:5px;
    border:1px solid #039aff;
    color:#039aff;
    margin-right:10px;
    margin-bottom:5px;
    font-size:12px;
    font-style:oblique;
}
.content-item-feel{
    position: absolute;
    left:0;
    top:0;
    padding:10px 16px;
    background:black;
    opacity: 0.4;
    color:#fff;
    font-size:12px;
}
.content-item-hot{
    background:#ffa51f;
    padding:8px 12px;
    color:#fff;
    position: absolute;
    left:0;
    top:164px;
    font-size:12px;
}
.content-left-content-table{
    /* border-top:1px solid #e8e8e8;
    border-left:1px solid #e8e8e8; */
    font-size:10px;
}
.content-left-content-table-title{
    height:84px;
    line-height: 84px;
    border:1px solid #e6e6e6;
    background:#fcfcfc;
    padding-left:20px;
    font-size: 40px;
    color:#0080cc;
}
.content-left-content-table-header{
    display:flex;
    height:46px;
    line-height:46px;
    background:#f3f3f3;
    color:#8c8c8c;
    font-size:14px;
}
.table-header-item{
    flex:1;
    text-align:center;
    border-right:1px solid #e8e8e8;
    border-bottom:1px solid #e8e8e8;
}
.content-left-content-table-body{
    display:flex;
    align-items: center;
    justify-content: center;
    height:90px;
    color:#8c8c8c;
}
.table-body-item{
    flex:1;
    text-align:center;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right:1px solid #eee;
    border-bottom:1px solid #eee;
    /* height:60px; */
    height:100%;
}
.content-left-content-introduce{
    margin-top:8px;
    line-height: 1.5;
}

.content-left-content-last{
    width:100%;
    margin-top:28px;
    position: relative;
}
.routerDetail-question-box{
    width:100%;
    margin-bottom:20px;
    border-bottom:1px solid #eee;
}
.routerDetail-question{
    width:100%;
    display:flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom:20px;
}
.routerDetail-question-one{
    width:18px;
    height:18px;
    line-height:18px;
    text-align: center;
    background:#ff9911;
    color:#fff;
    font-size:12px;
    border-radius: 50%;
    margin-right:10px;
}
.routerDetail-question-two{
    font-size:14px;
    flex:1;
    text-align: left;
}
.routerDetail-question-three{
    text-align: right;
    color:#b0b0b0;
    font-size:14px;
}
.routerDetail-question-answer{
    display:flex;
    align-items: flex-start;
    margin-bottom:20px;
}
.routerDetail-question-answer-one{
    width:18px;
    height:18px;
    line-height:18px;
    text-align: center;
    background:#2ca4ec;
    color:#fff;
    font-size:12px;
    border-radius: 50%;
    margin-right:10px;
}
.routerDetail-question-answer-two{
    font-size: 14px;
    color:#6f6f6f;
    flex: 1;
}
.routerDetail-question-answer-keep{
    font-size: 14px;
    color:#0080cc;
    padding-left:25px;
    box-sizing: border-box;
    margin-bottom:20px;
}
.steamerTicket-content-right{
    flex:0 0 334px;
    border-left:1px solid #eee;
    padding:0 24px;
    box-sizing: border-box;
}
.routeDetail-btns{
    padding-bottom:20px;
    border-bottom:1px solid #eee;
}
.routeDetail-btn{
    margin-top:20px;
    box-sizing: border-box;
    height:46px;
    line-height:46px;
    color:#fff;
    background:#ff6600;
    text-align: center;
    border-radius: 5px;
    display:flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    cursor: pointer;
}
.btn1{
    background:#ff6600;
}
.btn2{
    background:#029acc;
}
.btn3{
    background:#029acc;
}
.steamerTicket-content-right-route{

}
.content-right-route-title{
    /* height:56px;
    line-height: 56px; */
    padding-top:20px;
    font-size:18px;
    font-weight:bold;
}

.steamerTicket-like{
    width: 1280px;
    margin: 0 auto;
    margin-top:20px;
    /* margin-top:24px; */
    /* transform: translateY(-172px); */
    background:#fff;
    padding:24px;
    box-sizing: border-box;
}
.steamerTicket-like-title{
    margin-bottom:20px;
    display:flex;
    justify-content: space-between;
    align-items: center;
}
.routeDetail-left-tabtitle{
    display: flex;
    align-items: center;
}
.fl{
    float:left;
}
.fr{
    float:right;
}
.steamerTicket-like-title-right {
    font-size:14px;color:#7f8286;
    cursor: pointer;
}
.steamerTicket-like-title-right .imgg{
    background: url(../assets/img/refresh-icon-gray.png) no-repeat;
    width:14px;
    height:14px;
    display: inline-block;
    margin-top:3px;
    margin-left:3px;
}
.steamerTicket-like-title-right:hover{
    color:#0281cc;
}
.steamerTicket-like-title-right:hover .imgg{
    background: url(../assets/img/refresh-icon.png);
}
</style>



// WEBPACK FOOTER //
// src/views/routeDetail.vue